export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7758.69b57c38.jpg";